import "../../../style/globals/PageHeaderTitle.css";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import WrapperStyle from "../../../utils/WrapperStyle";
import PaymentIcon from "@mui/icons-material/Payment";

const PaymentTitle = () => {
  return (
    <div className="page-header-title" style={WrapperStyle()}>
      <div className="page-header-title-wrapper">
        <div className="page-header-title-headline">
          <PaymentIcon
            sx={{
              width: "24px!important",
              height: "24px!important",
            }}
          />
          <h1>Bakiye Yükle</h1>
        </div>
        {/* <div className="page-header-title-how-link">
          <HelpOutlineOutlinedIcon />
          <span>Bu Sayfa Nasıl Kullanılır?</span>
        </div> */}
      </div>
    </div>
  );
};

export default PaymentTitle;
